import { render, staticRenderFns } from "./MemberCancellation.vue?vue&type=template&id=16007182"
import script from "./MemberCancellation.vue?vue&type=script&lang=js"
export * from "./MemberCancellation.vue?vue&type=script&lang=js"
import style0 from "./MemberCancellation.vue?vue&type=style&index=0&id=16007182&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports